<template>
  <v-container fluid class="monitorSite px-4">
    <div class="align-left"><a class="text-color" :href="'#/admin/reports/reportdetails'" @click="reportMain">Report Summary Page</a> &gt;&gt; Details Page</div>
    <h1 ref="reportTitle">{{ this.reportTitle }}: <a  @click="inpersonateOfficeClicked">{{ this.agencyName }}</a> ({{ this.numRecords }} records)</h1>

    <!-- <textarea style="border:solid 1px;padding:10px;min-width:800px;min-height:150px" id="csvResult">Press the "Show export text" button to view exported CSV here</textarea> -->
    <br />

<div class="key">Key: FFRDC = Federally Funded Research and Development Center; FOSE = Field of Science and Engineering; nec = not elsewhere classified; U&Cs = Universities and Colleges</div>

    <div flex-nowrap class="float-right">
      <!-- <v-btn v-on:click="onBtnUpdate()">Show export text</v-btn> -->
      <v-btn class="button" color="secondary" v-on:click="onBtnExport()">Export to file</v-btn>
    </div>

    <div flex-nowrap class="float-left">
      <v-btn class="button" color="primary" v-on:click="sizeColumnsToFit()">Fit to Page</v-btn>
      <v-btn class="button" color="primary" v-on:click="autoSizeColumns(true)">Auto-Fit Data</v-btn>
      <v-btn class="button" color="primary" v-on:click="autoSizeColumns(false)">Auto-Fit All</v-btn>
    </div>

    <div style="clear: both;"></div>

    <div class="grid">
      <ag-grid-vue
        id="myGrid"
        style="width: 100%; height: 100%;"
        class="ag-theme-balham center-box elevation-2"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :gridOptions="gridOptions"
      ></ag-grid-vue>
    </div>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { AgGridVue } from "ag-grid-vue";
import router from "@/router";
import { adminService } from "@/services/adminService.js";
import { officeManagementService } from "@/services/officeManagementService.js";
import { authTokenService } from "@/services/authTokenService.js";

export default {
  name: "Report100MDetail",
  data: () => ({
    gridOptions: null,
    gridApi: null,
    columnApi: null,
    reportId: null,
    officeId: null,
    agencyName: null,
    numRecords: null,
    volumeId: null,
    reportTitle: "100 Million Dollar Differences Details",
    columnDefs: [],
    rowData: [],
    chartData: [],
    recordId: null,
    quesitonId: null,
    reportHeaders: [
      { headerName: "Q#", field: "questionId", width: 100, textAlign: "text-left", rowGroup: true },
      { headerName: "Data Collection Cell Name", field: "fieldTitle", width: 250, textAlign: "text-left", rowGroup: false },
      { headerName: "Record Code", field: "fieldCode", width: 150, textAlign: "text-left", rowGroup: false },
      { headerName: "Previous Volume", field: "fieldValuePreVolume", width: 150, textAlign: "text-right", rowGroup: false, valueFormatter: currencyFormatter },
      { headerName: "Current Volume", field: "fieldValue", width: 150, textAlign: "text-right", rowGroup: false, valueFormatter: currencyFormatter },
      { headerName: "$ Difference", field: "difference", width: 150, textAlign: "text-right", rowGroup: false, valueFormatter: currencyFormatter },
      { headerName: "% Difference", field: "percentDifference", width: 150, textAlign: "text-right", rowGroup: false, valueFormatter: percentFormatter },
      { headerName: "Comments", field: "explanation", width: 300, textAlign: "text-left", rowGroup: false }
    ],
    office: null,
    surveyRoot: null
  }),
  components: {
    AgGridVue
  },
  created () {
    this.officeId = this.$route.params.officeId;
    this.agencyName = this.$route.params.agencyName;
    this.volumeId = this.$route.params.volumeId;
  },
  beforeMount () {
    this.gridOptions = {};
  },
  mounted () {
    let me = this;

    me.gridApi = me.gridOptions.api;
    me.gridColumnApi = me.gridOptions.columnApi;

    for (var i = 0; i < this.reportHeaders.length; i++) {
      var tmpColumnDef = {};
      if (me.reportHeaders[i].headerName === 'Previous Volume') {
        tmpColumnDef.headerName = "Volume " + (this.volumeId - 1);
      } else if (me.reportHeaders[i].headerName === 'Current Volume') {
        tmpColumnDef.headerName = "Volume " + this.volumeId;
      } else {
        tmpColumnDef.headerName = this.reportHeaders[i].headerName;
      }
      tmpColumnDef.field = me.reportHeaders[i].field;
      tmpColumnDef.width = me.reportHeaders[i].width;
      tmpColumnDef.sortable = true;
      tmpColumnDef.filter = true;
      tmpColumnDef.resizable = true;
      tmpColumnDef.cellClass = me.reportHeaders[i].textAlign;
      tmpColumnDef.valueFormatter = me.reportHeaders[i].valueFormatter;
      me.columnDefs.push(tmpColumnDef);
    }

    adminService
      .getReportRecords(me.officeId, me.volumeId)
      .then(function (resp) {
        me.rowData = resp.data;
        me.numRecords = me.rowData.length;
        for (var i = 0; i < me.rowData.length; i++) {
          me.rowData[i].fieldTitle = me.updTextWithFy(me.rowData[i].fieldTitle);
          // me.rowData[i].fieldValuePreVolume = me.currencyFormatter(me.rowData[i].fieldValuePreVolume);
          // me.rowData[i].fieldValue = me.currencyFormatter(me.rowData[i].fieldValue);
          // me.rowData[i].difference = me.currencyFormatter(me.rowData[i].difference);
          // me.rowData[i].percentDifference = me.percentFormatter(me.rowData[i].percentDifference);
          me.questionId = me.rowData[i].questionId;
        }
      })
      .catch(function (err) {
        console.error(err);
      });

    officeManagementService
      .getSurveyByOfficeId(me.officeId)
      .then(function (response) {
        me.surveyRoot = response.data;
      })
      .catch(function (err) {
        console.log(err);
        console.log("Error getting survey by office id.");
        throw err;
      });
  },

  methods: {
    sizeColumnsToFit () {
      this.gridApi.sizeColumnsToFit();
    },
    // autoSizeColumns (header) {
    //    this.gridColumnApi.autoSizeColumns (this.columnFieldNames, header);
    // },
    reportMain () {
      router.push({
        name: "admin.reportdetails"
      });
    },
    autoSizeColumns (header) {
      var tmpColumns = [];
      for (var i = 0; i < this.reportHeaders.length; i++) {
        tmpColumns.push(this.reportHeaders[i].field);
      }
      this.gridColumnApi.autoSizeColumns(tmpColumns, header);
    },
    onBtnExport () {
      var params = this.getParams();
      if (params.suppressQuotes || params.columnSeparator) {
        alert(
          'NOTE: you are downloading a file with non-standard quotes or separators - it may not render correctly in Excel.'
        );
      }
      this.gridApi.exportDataAsCsv(params);
    },
    onBtnUpdate () {
      document.querySelector('#csvResult').value = this.gridApi.getDataAsCsv(
        this.getParams()
      );
    },
    getParams () {
      return {
        suppressQuotes: false,
        columnSeparator: false,
        customHeader: [
            [
              { data: { value: ' ', type: 'String' } },
              { data: { value: '100 Million Dollar Differences Details: ', type: 'String' } },
              { data: { value: this.agencyName, type: 'String' } }
            ],
            []
        ],
        customFooter: [],
        fileName: "100MDiffRptDet_" + this.officeId
      };
    },
    // currencyFormatter (number) {
    //   return '$' + this.formatNumber(number);
    // },
    // percentFormatter (number) {
    //   return number + '%';
    // },
    // formatNumber (number) {
    //   return Math.floor(number)
    //     .toString()
    //     .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    // },
    updTextWithFy (origText) {
      var updText = origText;
      updText = updText.toString().replace('#1#', this.volumeId - 1);
      updText = updText.toString().replace('#2#', this.volumeId);
      return updText;
    },
    inpersonateOfficeClicked () {
      if (this.surveyRoot.id != null) {
        authTokenService.setActiveSurveyId(this.surveyRoot.id);
        router.push({ name: "home" });
      } else {
        console.log("Impersonation error: null survey ID");
      }
    },
    onGridReady (params) {}
  }
}

window.currencyFormatter = function currencyFormatter (params) {
  return '$' + formatNumber(params.value);
};

window.formatNumber = function formatNumber (number) {
  return Math.floor(number)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

window.percentFormatter = function percentFormatter (params) {
  return params.value + '%';
};

</script>

<style scoped>
.align-left {
  text-align: left;
}
.float-left {
	float: left;
}
.float-right {
	float: right;
}
.button {
  max-height: 25px;
  margin: 10px 10px 10px 0px;
}
h1 {
  margin: 0px 0 20px 0;
}
.text-color {
  color: #14427d;
}
.grid {
  width: 100%;
  height: 70vh;
  border: 1px solid
}
.key {
  text-align: left;
  font-size: smaller;
  margin-left: 2px;
  color: #14427d;
}
</style>
